import { render, staticRenderFns } from "./BenefitGroupDetail.vue?vue&type=template&id=164f1adf&"
import script from "./BenefitGroupDetail.vue?vue&type=script&lang=js&"
export * from "./BenefitGroupDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports